import './styles.scss'
import React, { useMemo } from 'react'
import { I18n } from 'react-redux-i18n'

import ReactQuill from 'react-quill'
import EmojiSelector from 'components/EmojiSelector'
import { ButtonTag } from 'components/Form'
import { quillEditorModulesByChannel } from 'utils'
import { getStaticImage } from 'utils/statics'

const TextEditorHTMLUI = ({ quillRef, id, channel, value, options, placeholder, className, handleOnChange, uploadFiles, onPreviewMsg, isOpenEmojis, onToggleEmojis, onSelectEmoji, errors }) => (
  <div className='text-editor-html'>
    <ReactQuill
      ref={quillRef}
      id={id}
      defaultValue={value}
      className={className}
      placeholder={placeholder}
      onChange={handleOnChange}
      modules={useMemo(() => quillEditorModulesByChannel({ channel, uploadFiles, quillRef: quillRef.current }).modules, [quillRef.current])}
      formats={useMemo(() => quillEditorModulesByChannel({ channel, uploadFiles, quillRef: quillRef.current }).formats, [quillRef.current])}
    />
    <div className='text-editor-html__options'>
      {options.find(option => option === 'preview') && (
        <div className='text-editor-html__preview'>
          <ButtonTag
            value={I18n.t('dashboard_preview')}
            onClick={onPreviewMsg}
          />
        </div>
      )}
      {options.find(option => option === 'emojis') && (
        <button type='button' className='text-editor-html__emojis' onClick={onToggleEmojis}>
          <img src={getStaticImage('/icons/orange-brand/editor-emoji.svg')} alt='Emojis' />
        </button>
      )}
    </div>
    <EmojiSelector showEmojis={isOpenEmojis} handleToggle={onToggleEmojis} handleSelect={onSelectEmoji} />
  </div>
)

export { TextEditorHTMLUI }
